import { NavBar } from 'components/NavBar/NavBar'
import { TextDisplayCard } from 'components/TextDisplayCard/TextDisplayCard'
import { clearReceipt, getSingleInventoryReceipt } from 'features/inventory/inventoryReceiptsSlice'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import { Box, Flex, H1WithBack, ItemsGrid, PageWrapper, ThinSeparator } from 'styling/GlobalStyles'
import { formatDateForDisplay } from 'utils/helpers'
import { receiptsOptions } from './receiptsData'
import { BodyText, TitleText } from 'styling/Typography'
import { OptionsFileIcon } from 'assets/icons/OptionsFileIcon'

export const SingleReceipt: React.FC = () => {
    const { id } = useParams()
    const dispatch = useDispatch<AppDispatch>()
    const { singleReceipt } = useSelector((state: RootState) => state.inventoryReceipts)

    useEffect(() => {
        dispatch(getSingleInventoryReceipt(id))
        return () => {
            dispatch(clearReceipt())
        }
    }, [id])

    return <>
        <NavBar />
        <PageWrapper noFooter >
            <Flex between mb='16' >
                <H1WithBack title='Receipt preview' arrow />
            </Flex>
            <ItemsGrid columns={3} >
                <TextDisplayCard width='100%' labelText='Receipt Number' title={singleReceipt?.receiptNo} />
                <TextDisplayCard width='100%' labelText='Receipt Date' title={formatDateForDisplay(singleReceipt?.receiptDate)} />
                <TextDisplayCard width='100%' labelText='Supplier' title={singleReceipt?.supplier?.name} />
                <TextDisplayCard width='100%' labelText='Location' title={singleReceipt?.location?.name} />
                <TextDisplayCard width='100%' labelText='Status' title={receiptsOptions.find(s => s.value == singleReceipt?.status)?.label} />
                <TextDisplayCard width='100%' labelText='Currency' title={singleReceipt?.currency} />
                <TextDisplayCard width='100%' labelText='Total Amount' title={singleReceipt?.totalAmount} />
                <TextDisplayCard width='100%' labelText='Notes' title={singleReceipt?.notes ?? '/'} />
            </ItemsGrid >
            {singleReceipt?.attachmentUrl && <Flex mt='20' gap='1rem' center >
                <OptionsFileIcon />
                <a href={singleReceipt?.attachmentUrl} ><BodyText style={{ textDecoration: 'underline' }} >Download Attachment</BodyText></a>
            </Flex>}
            <ThinSeparator />
            <TitleText weight='bold' style={{ marginBottom: '1rem' }}>Batches: </TitleText>
            {!singleReceipt?.batches?.length ? <TitleText>No batches</TitleText> : <Flex gap='1rem' >
                {singleReceipt?.batches.map(b => <Box key={b.id} width='100%'>
                    <Flex gap='1rem' width='100%' alignEnd >
                        <TextDisplayCard width='100%' style={{ flex: 1 }} labelText='Item' title={b?.item?.name} />
                        <TextDisplayCard width='100%' style={{ flex: 1 }} labelText='Batch Code' title={b?.batchCode} />
                        <TextDisplayCard width='100%' style={{ flex: 1 }} labelText='Initial location' title={b?.initialLocation?.name} />
                        <TextDisplayCard width='100%' style={{ flex: 1 }} labelText='Quantity' title={b?.quantity} />
                        <TextDisplayCard width='100%' style={{ flex: 1 }} labelText='Unit Cost' title={b?.unitCost} />
                        <TextDisplayCard width='100%' style={{ flex: 1 }} labelText='Unit' title={b?.unit?.name} />
                        <TextDisplayCard width='100%' style={{ flex: 1 }} labelText='MFG Date' title={formatDateForDisplay(b.mfgDate)} />
                        <TextDisplayCard width='100%' style={{ flex: 1 }} labelText='Expiry Date' title={formatDateForDisplay(b.expiryDate)} />
                    </Flex>
                    {b.serials?.length > 0 && <>
                        <ThinSeparator />
                        <TitleText weight='bold' >Serials:</TitleText>
                        <Flex width='100%' gap='1rem' wrap alignEnd>
                            {b.serials.map((s, i) => <Box width='20rem' key={i}  >
                                <Flex mb='16' width='100%' between >
                                    <BodyText weight='bold' >Serial {i + 1}</BodyText>
                                </Flex>
                                <Flex column gap='1rem' alignEnd >
                                    <TextDisplayCard style={{ flex: 1 }} labelText='Serial Number' title={s.serialNo} />
                                    <TextDisplayCard style={{ flex: 1 }} labelText='Warranty Expiry' title={formatDateForDisplay(s.warrantyExpiry)} />
                                </Flex>
                            </Box>)}
                        </Flex>
                    </>}
                </Box>)}
            </Flex>}
        </PageWrapper>
    </>
}